import { Strings } from '../string/string';

export const LogLevel = {
    Trace: 0,
    Debug: 1,
    Info: 2,
    Warning: 3,
    Error: 4,
    Critical: 5,

    getLevel(value: number): string {
        return Object.keys(LogLevel).find(key => (<any>LogLevel)[key] === value) ?? Strings.Empty;
    }
};
